import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "display-flex ion-justify-content-center" }
const _hoisted_2 = { class: "display-flex ion-justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_lottie_animation = _resolveComponent("lottie-animation")!

  return (_openBlock(), _createElementBlock("view", null, [
    _createElementVNode("view", _hoisted_1, [
      _createVNode(_component_ion_label, { class: "empty-container-message ion-text-center" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.message), 1)
        ]),
        _: 1
      })
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("view", _hoisted_2, [
      _createVNode(_component_lottie_animation, {
        class: "empty-container-animation",
        "animation-data": _ctx.emptyDefinitionAnimation,
        loop: true
      }, {
        fallback: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.faMehBlank,
            class: "firecracker-primary-color-icon-large"
          }, null, 8, ["icon"])
        ]),
        _: 1
      }, 8, ["animation-data"])
    ])
  ]))
}